<template>
    <div>
        <kgr-letter-signatures-button
            :letter="letter"
            view="employee"
            @click="openModalAndStartSigning"
        />

        <kgr-letter-signatures-modal
            v-if="signingStarted"
            :letter="letter"
            @close="closeModal"
            @saved="onSave"
        />
    </div>
</template>

<script>
import LetterSignaturesButton from './LetterSignaturesButton.vue';
import LetterSignaturesModal from './LetterSignaturesModal.vue';
import SignableLetter from '../../../js/dto/letter/SignableLetter.js';

export default {
    components: {
        'kgr-letter-signatures-modal': LetterSignaturesModal,
        'kgr-letter-signatures-button': LetterSignaturesButton,
    },
    props: {
        letter: {
            type: SignableLetter,
            required: true,
        },
    },
    data() {
        return {
            signingStarted: false,
        };
    },
    computed: {
        disabled() {
            return this.letter.getSignableSignatures().length === 0 || !this.letter.isAllowedToEdit;
        },
    },
    methods: {
        openModalAndStartSigning() {
            if (this.letter.getSignableSignatures().length === 0 || !this.letter.isAllowedToEdit) {
                return;
            }
            this.signingStarted = true;
        },
        closeModal() {
            this.signingStarted = false;
        },
        onSave($event) {
            this.$emit('saved', $event);
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
